// eslint:disable max-line-length
import { validationHighlights, validationPrefixHighlights } from 'app/area/administration/shared/helpers';
import { CodetableTranslation } from 'app/area/codetable/constants';
import {
  shouldRenderDetails, shouldRenderTranslations
} from 'app/area/codetable/item/codetable-item-form-render-helpers';
import { CodeEditSectionType, MetroLineConfigurationPayload } from 'app/area/codetable/item/types';
import { CodeFieldWireKey, CodetableFeature } from 'app/area/codetable/types-store';
import { Configuration } from 'app/components/metro-line/types';
import { routeConstants } from 'app/routes/route-constants';

export const uomConfiguration = ({ metadata, breadcrumbs, codeId, actionType, validationErrors,
  detailsSectionRef, visibilitySectionRef, translationsSectionRef, uomConversionSectionRef
}: MetroLineConfigurationPayload):
  Configuration<CodeEditSectionType>[] => ([
    {
      section: CodeEditSectionType.Details,
      visible: shouldRenderDetails(metadata),
      iconUrl: '/i/case-sections/default.svg',
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.Details, actionType),
      label: (translation: CodetableTranslation) => translation.details,
      ref: detailsSectionRef,
      isValid: validationHighlights(
        [CodetableFeature.disabled, CodetableFeature.category, CodetableFeature.measurementSystem],
        validationErrors
      )
    },
    {
      section: CodeEditSectionType.UomConversion,
      visible: true,
      iconUrl: '/i/case-sections/where-and-what.svg',
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.UomConversion, actionType),
      label: (translation: CodetableTranslation) => translation.uom_conversion,
      ref: uomConversionSectionRef,
      isValid: validationPrefixHighlights([CodeFieldWireKey.factor], validationErrors)
    },
    {
      section: CodeEditSectionType.Visibility,
      visible: true,
      iconUrl: '/i/case-sections/where-and-what.svg',
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.Visibility, actionType),
      label: (translation: CodetableTranslation) => translation.visibility,
      ref: visibilitySectionRef,
      isValid: validationHighlights([CodeFieldWireKey.application, CodeFieldWireKey.subset], validationErrors)
    },
    {
      section: CodeEditSectionType.Translations,
      visible: shouldRenderTranslations(metadata),
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.Translations, actionType),
      iconUrl: '/i/case-sections/actions.svg',
      label: (translation: CodetableTranslation) => translation.descriptions_and_translations,
      ref: translationsSectionRef,
      isValid: validationHighlights([CodetableFeature.language], validationErrors)
    }
  ]);
